import { InvoiceStatus } from "../../domain/enum/invoiceStatus.enum"
import { Seller } from "./Seller"

export interface InvoiceTransaction {
	id: number
	userEmail: string
	userName?: string
	marketplace?: string
	micrositeId?: number
	micrositeSlug?: string
	serviceTitle: string
	serviceSessionTitle: string
	paymentFinalAmount: number
	units: number
	sellerPrice?: number | null
	sellerFee?: number | null
	reservationDate: string
	totalFee: number
	ivaPercentage: number
	iva: number
	total: number
	sellerPayment: number
	sellerOfficeName?: string | null
}

interface ConstructorParams {
	id: number
	invoiceNumber: string
	createdAt: Date
	paymentDate?: string | null
	emissionDate?: string | null
	period: string
	sellerId: number
	status: InvoiceStatus
	total: number
	totalFee: number
	transactions?: InvoiceTransaction[]
	sellerPrice: number
	sellerPayment: number
	sellerPaymentDate?: string | null
	sellerCollectionDate?: string | null
	seller?: Seller
	sellerOfficeId?: number | null
	sellerOfficeName?: string | null
}

export class Invoice {
	public id: number
	public invoiceNumber: string
	public createdAt: Date
	public paymentDate?: string | null
	public emissionDate?: string | null
	public period: string
	public sellerId: number
	public status: InvoiceStatus
	public total: number
	public totalFee: number
	public sellerPrice: number
	public sellerPayment: number
	public sellerPaymentDate?: string | null
	public sellerCollectionDate?: string | null
	public transactions?: InvoiceTransaction[]
	public seller?: Seller
	public sellerOfficeId?: number | null
	public sellerOfficeName?: string | null

	public constructor(invoice: ConstructorParams) {
		this.id = invoice.id
		this.invoiceNumber = invoice.invoiceNumber
		this.createdAt = invoice.createdAt
		this.paymentDate = invoice.paymentDate
		this.emissionDate = invoice.emissionDate
		this.period = invoice.period
		this.sellerId = invoice.sellerId
		this.status = invoice.status
		this.total = invoice.total
		this.totalFee = invoice.totalFee
		this.sellerPaymentDate = invoice.sellerPaymentDate
		this.sellerCollectionDate = invoice.sellerCollectionDate
		this.transactions = invoice.transactions
		this.sellerPrice = invoice.sellerPrice
		this.sellerPayment = invoice.sellerPayment
		this.seller = invoice.seller
		this.sellerOfficeName = invoice.sellerOfficeName
		this.sellerOfficeId = invoice.sellerOfficeId
	}
}
